import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { DEFAULT_LOCALE, type Locale } from '@nexops/shared';

export type ThemePreference = 'light' | 'dark' | 'system';

interface UiState {
  theme: ThemePreference;
  locale: Locale;
  sidebarCollapsed: boolean;
  /** Rozwinięte grupy menu bocznego (klucze grup). */
  openNavGroups: string[];
  setTheme: (theme: ThemePreference) => void;
  setLocale: (locale: Locale) => void;
  toggleSidebar: () => void;
  setNavGroupOpen: (key: string, open: boolean) => void;
}

/**
 * Per-device UI preferences (theme, language, sidebar and its open menu groups). Persisted in localStorage under `nexops-ui-v2`
 * — `index.html` reads `state.theme` before first paint to avoid a theme flash.
 */
export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      theme: 'light',
      locale: DEFAULT_LOCALE,
      sidebarCollapsed: false,
      openNavGroups: [],
      setTheme: (theme) => set({ theme }),
      setLocale: (locale) => set({ locale }),
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setNavGroupOpen: (key, open) =>
        set((s) => ({ openNavGroups: open ? [...new Set([...s.openNavGroups, key])] : s.openNavGroups.filter((k) => k !== key) })),
    }),
    {
      name: 'nexops-ui-v2',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ theme: s.theme, locale: s.locale, sidebarCollapsed: s.sidebarCollapsed, openNavGroups: s.openNavGroups }),
    },
  ),
);
